<header class="page-header">
  <h1>{{ 'page.settings.name' | translate | upperFirstLetter }}</h1>
</header>

<section>
  <header>
    <h2 class="title"><kin-icon name="filter" />{{ 'page.settings.display.title' | translate }}</h2>
    <p>{{ 'page.settings.display.subtitle' | translate }}</p>
  </header>

  <ul>
    <li class="fieldset profile">
      @if (avatarUrl) {
        <img class="avatar" [src]="avatarUrl" />
      } @else {
        <kin-skeleton [height]="32" [width]="32" shape="circle" />
      }
      <p class="section-title">
        {{ 'page.settings.display.profile.title' | translate | upperFirstLetter }}
      </p>
      <p class="username">{{ username }}</p>
      <a class="link end-row" (click)="navigateToWebsiteProfile()">
        <span>{{ 'page.settings.display.language.button' | translate | upperFirstLetter }}</span>
        <kin-icon [color]="colorService.brandSecondary600()" name="external" />
      </a>
    </li>
    <li class="fieldset language">
      <kin-icon name="language" [size]="30" />
      <p class="section-title">
        {{ 'page.settings.display.language.title' | translate | upperFirstLetter }}
      </p>
      <app-language-select class="end-row" />
    </li>
  </ul>
</section>
<a class="disconnect link" (click)="logout()">
  <kin-icon [color]="colorService.danger500()" name="logout" />
  <span>{{ 'common.logout' | translate | upperFirstLetter }}</span>
</a>
